import type { Product } from "@decocms/apps-commerce/types";
import BuyTogetherIsland from "~/components/BuyTogether";

export interface Props {
  products: Product[] | null;
  title?: string;
  hideButton?: boolean;
}
function BuyTogether(
  { products, title, hideButton }: Props,
) {
  if (!products || products.length === 0) {
    return null;
  }
  return (
    <div className="w-full container py-10 flex flex-col gap-3 lg:gap-6 lg:p-0 relative mt-0 lg:mt-20 max-w-[1238px] m-auto">
      <p className="text-[#333333] text-2xl font-medium lg:text-[32px] uppercase px-2 lg:px-0">
        {title}
      </p>
      <BuyTogetherIsland products={products} hideButton={hideButton} />
    </div>
  );
}
export const loader = (props: Props) => props;
export default BuyTogether;
